export default class Modal {

    constructor() {
        this.settings = {
            $modal : $(".js-modal"),
            $modalTrigger : $(".js-modal-trigger"),
            $modalClose : $(".js-modal-close")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$modalTrigger != null && this.settings.$modal != null) {

            this.settings.$modalTrigger.on('click', function() {

                let id = $(this).data( "modal-trigger" );
                $('#'+id).toggleClass('hidden');

            });

            this.settings.$modalClose.on('click', function() {

                let parentId = $(this).closest('.js-modal').attr('id');
                $('#'+parentId).toggleClass('hidden');

            });

        }

        // Product guide modals
        if ($('body').hasClass('single-product')) {

            $('body.single-product').on('click', '.guide-modal-open', (e) => {
                const productInfoId = $(e.currentTarget).attr('data-product_info');

                $('#guide-modal .product-guide-item').addClass('hidden');
                $('#guide-modal').modal('show');

                if ($('#product-guide-' + productInfoId).length) {
                    $('#product-guide-' + productInfoId).removeClass('hidden');
                    return;
                }

                $.ajax({
                    url: '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: 'action=get_guide&product_info_id=' + productInfoId,
                    success: (data) => {
                        $('#guide-modal .modal-content').append(data);
                    },
                    error: (error) => {
                        console.log(error);
                    }
                });
            });

            $('body.single-product').on('click', '#guide-modal .close-modal', (e) => {
                $(e.currentTarget).closest('.modal').modal('hide');
            });
        }

    }
};

new Modal();